import styled from "styled-components";
import { gnbConst } from "../constants/gnbConst";
import { BoxButtonTitle, CommmonBoxLayout, CommonLayout, FlexBox, InputLinkBox } from "../style/common";
import TitleAndInput from "../components/common/TitleAndInput";
import Btn from "../components/common/Btn";
import { useEffect, useState } from "react";
import { getTaskList, getWordTaskList, putTaskList } from "../api/task";
import { stringToJson } from "../utils/stringToJson";
import { getSettings, postSettings } from "../api/settings";
import { useAlertStore } from "../store/alertStore";
import { memberChangePw, memberList, memberUpdate } from "../api/member";
import { useMemberStore } from "../store/memberStore";
import { useNavigatePage } from "../hooks/useNavigatePage";

export default function Setting() {
  const pageTitle = gnbConst[6].title;
  const { memberPermitLevel } = useMemberStore();
  const { onMovementPage } = useNavigatePage();
  const setAlert = useAlertStore((state) => state.setAlert);
  const [settingsData, getSettingsData] = useState<SettingsResponse>();
  const [taskData, getTaskData] = useState<GetTaskListResponse>();
  const [wordTaskData, setWordTaskData] = useState<GetTaskListResponse>();
  const [apiKey, setApiKey] = useState("");
  const [promptVal, setPromptVal] = useState("");
  const [wordVal, setWordVal] = useState("");
  const [modelVal, setModelVal] = useState("");
  const [adminObj, setAdminObj] = useState<MemberListUserItem>();
  const [admin2Obj, setAdmin2Obj] = useState<MemberListUserItem>();
  const [adminPw, setAdminPw] = useState("");
  const [admin2Pw, setAdmin2Pw] = useState("");
  const [adminAllowIp, setAdminAllowIp] = useState("");
  const [admin2AllowIp, setAdmin2AllowIp] = useState("");

  useEffect(() => {
    if (gnbConst[0].level > memberPermitLevel) {
      alert("접근 권한이 없습니다.");
      onMovementPage(-1);
    }
  }, [memberPermitLevel]);

  useEffect(() => {
    const apiGetTaskList = async () => {
      try {
        const memberListProps = {
          search: "200",
          search_field: "member_permit_level",
        };

        const [
          taskResponse,
          wordTaskResponse,
          settingsResponse,
          adminResponse,
        ] = await Promise.all([
          getTaskList(),
          getWordTaskList(),
          getSettings(),
          memberList(memberListProps),
        ]);

        if (taskResponse.statusCode === 200) {
          const taskData = taskResponse.list[0];

          if (taskData.task_params) {
            getTaskData(taskResponse);

            const taskParams = stringToJson(taskData.task_params);
            setPromptVal(taskParams.prompt || "");
            setModelVal(taskParams.model || "gpt-3.5-turbo");
          }
        }

        if (wordTaskResponse.statusCode === 200) {
          const wordTask = wordTaskResponse.list[0];

          setWordTaskData(wordTaskResponse);
          setWordVal(wordTask.task_params || "");
        }

        if (settingsResponse.statusCode === 200) {
          getSettingsData(settingsResponse);
          setApiKey(settingsResponse.data?.openai_key || "");
        }

        if (adminResponse.statusCode === 200) {
          const adminResponseList = adminResponse.list;

          if (adminResponseList) {
            for (let adminItem of adminResponseList) {
              if (adminItem.member_id === "admin") {
                setAdminObj(adminItem);
                setAdminAllowIp(adminItem.member_allow_ip || "");
              } else {
                setAdmin2Obj(adminItem);
                setAdmin2AllowIp(adminItem.member_allow_ip || "");
              }
            }
          }
        }
      } catch (error) { }
    };

    apiGetTaskList();
  }, []);

  const apiPutClick = async () => {
    try {
      const task_params = { prompt: promptVal, model: modelVal };
      const taskPropsData = {
        idx: taskData?.list[0].idx,
        task_idx: taskData?.list[0].task_idx,
        module_idx: taskData?.list[0].module_idx,
        task_params: JSON.stringify(task_params),
      };

      const wordTaskPropsData = {
        idx: wordTaskData?.list[0].idx,
        task_idx: wordTaskData?.list[0].task_idx,
        module_idx: wordTaskData?.list[0].module_idx,
        task_params: wordVal,
      };

      const settingsPropsData = {
        ...settingsData,
        openai_key: apiKey,
      }

      const [
        taskResponse,
        wordTaskResponse,
        settingsResponse,
      ] = await Promise.all([
        putTaskList(taskPropsData),
        putTaskList(wordTaskPropsData),
        postSettings(settingsPropsData),
      ]);

      if (taskResponse.statusCode === 200 && wordTaskResponse.statusCode === 200 && settingsResponse.statusCode === 200) {
        setAlert("AI용 모델 API KEY 설정이 변경되었습니다.", "green");
      }
    } catch (error) { }
  }

  const apiPutAdminClick = async () => {
    try {
      const adminPwVal = adminPw.trim();
      const admin2PwVal = admin2Pw.trim();
      const adminAllowIpVal = adminAllowIp.trim();
      const admin2AllowIpVal = admin2AllowIp.trim();

      // 비밀번호나 IP 중 하나라도 변경되었는지 확인
      const hasAdminChange = adminPwVal !== "" || adminAllowIpVal !== (adminObj?.member_allow_ip || "");
      const hasAdmin2Change = admin2PwVal !== "" || admin2AllowIpVal !== (admin2Obj?.member_allow_ip || "");

      if (!hasAdminChange && !hasAdmin2Change) {
        setAlert("변경할 내용이 없습니다.", "red");
        return;
      }

      let responseBool = true;

      // 관리자 비밀번호 변경
      if (adminPwVal !== "" && adminObj?.idx) {
        const memberChangePwProps = { idx: adminObj.idx as string, member_pw: adminPw };
        const response = await memberChangePw(memberChangePwProps);
        if (response.statusCode !== 200) {
          setAlert("관리자 비밀번호 변경 실패. 새로고침 후 다시 시도해주세요.", "red");
          responseBool = false;
        }
      }

      // 관리자 IP 접근 허용 변경
      if (adminObj?.idx && adminAllowIpVal !== (adminObj?.member_allow_ip || "")) {
        const memberUpdateProps = { idx: adminObj.idx as string, member_allow_ip: adminAllowIpVal };
        const response = await memberUpdate(memberUpdateProps);
        if (response.statusCode !== 200) {
          setAlert("관리자 IP 설정 변경 실패. 새로고침 후 다시 시도해주세요.", "red");
          responseBool = false;
        }
      }

      // 보조 관리자 비밀번호 변경
      if (admin2PwVal !== "" && admin2Obj?.idx) {
        const memberChangePwProps = { idx: admin2Obj.idx as string, member_pw: admin2Pw };
        const response = await memberChangePw(memberChangePwProps);
        if (response.statusCode !== 200) {
          setAlert("보조 관리자 비밀번호 변경 실패. 새로고침 후 다시 시도해주세요.", "red");
          responseBool = false;
        }
      }

      // 보조 관리자 IP 접근 허용 변경
      if (admin2Obj?.idx && admin2AllowIpVal !== (admin2Obj?.member_allow_ip || "")) {
        const memberUpdateProps = { idx: admin2Obj.idx as string, member_allow_ip: admin2AllowIpVal };
        const response = await memberUpdate(memberUpdateProps);
        if (response.statusCode !== 200) {
          setAlert("보조 관리자 IP 설정 변경 실패. 새로고침 후 다시 시도해주세요.", "red");
          responseBool = false;
        }
      }

      if (responseBool) {
        setAlert("설정이 변경되었습니다.", "green");
      }
    } catch (error) { }
  }

  return (
    <CommonLayout>
      <CommmonBoxLayout>
        <SettingBox>
          <BoxButtonTitle>
            {pageTitle}
            <Btn type="button" title="저장" color="blue" onClick={apiPutAdminClick} />
          </BoxButtonTitle>

          <InputLinkBox>
            <TitleAndInput
              title="관리자 아이디"
              type="none"
              value={adminObj?.member_id || ""}
              placeholder="관리자 아이디"
            />
            <TitleAndInput
              title="비밀번호"
              type="password"
              value={adminPw}
              onChange={(e) => setAdminPw(e.target.value)}
              placeholder="관리자 비밀번호"
            />
            <TitleAndInput
              title="IP 접근 허용"
              type="text"
              value={adminAllowIp}
              onChange={(e) => setAdminAllowIp(e.target.value)}
              placeholder="허용할 IP 주소"
            />
          </InputLinkBox>

          <InputLinkBox>
            <TitleAndInput
              title="보조 관리자"
              type="none"
              value={admin2Obj?.member_id || ""}
              placeholder="보조 관리자"
            />
            <TitleAndInput
              title="비밀번호"
              type="password"
              value={admin2Pw}
              onChange={(e) => setAdmin2Pw(e.target.value)}
              placeholder="보조 비밀번호"
            />
            <TitleAndInput
              title="IP 접근 허용"
              type="text"
              value={admin2AllowIp}
              onChange={(e) => setAdmin2AllowIp(e.target.value)}
              placeholder="허용할 IP 주소"
            />
          </InputLinkBox>

          {/* <InputLinkBox>
            <TitleAndInput
              title="페이지당 게시물 수"
              type="number"
              placeholder="페이지당 게시물 수"
            />
          </InputLinkBox> */}
        </SettingBox>

        <SettingBox>
          <BoxButtonTitle>
            AI용 모델 API KEY
            <Btn type="button" title="저장" color="blue" onClick={apiPutClick} />
          </BoxButtonTitle>

          <InputLinkBox>
            <FlexBox>
              {/* <InputTitle>gpt-4o-mini</InputTitle> */}
              <TitleAndInput
                title="API Key"
                type="textarea"
                value={apiKey || ""}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="API Key"
                score={true}
                inputWidth="40rem"
                height="6rem"
              />
            </FlexBox>
          </InputLinkBox>

          <InputLinkBox>
            <FlexBox>
              {/* <InputTitle></InputTitle> */}
              <TitleAndInput
                title="model"
                type="text"
                value={modelVal}
                onChange={(e) => setModelVal(e.target.value)}
                placeholder="AI model 입력해주세요."
                score={true}
                inputWidth="40rem"
              />
            </FlexBox>
          </InputLinkBox>

          <InputLinkBox>
            <FlexBox>
              {/* <InputTitle></InputTitle> */}
              <TitleAndInput
                title="prompt"
                type="textarea"
                value={promptVal}
                onChange={(e) => setPromptVal(e.target.value)}
                placeholder="AI prompt 입력해주세요."
                score={true}
                inputWidth="40rem"
                height="6rem"
              />
            </FlexBox>
          </InputLinkBox>

          <InputLinkBox>
            <FlexBox>
              {/* <InputTitle></InputTitle> */}
              <TitleAndInput
                title="word"
                type="textarea"
                value={wordVal}
                onChange={(e) => setWordVal(e.target.value)}
                placeholder="AI word 입력해주세요."
                score={true}
                inputWidth="40rem"
                height="6rem"
              />
            </FlexBox>
          </InputLinkBox>

          {/* <InputLinkBox>
            <FlexBox>
              <InputTitle>과금현황</InputTitle>
              <TitleAndInput
                title="총 사용량"
                type="text"
                value="토큰"
                placeholder="토큰"
                disabled={true}
                score={true}
              />
            </FlexBox>

            <TitleAndInput
              title="환산비용"
              type="text"
              value="20USD"
              placeholder="환산비용"
              disabled={true}
              score={true}
            />
          </InputLinkBox>

          <InputLinkBox>
            <FlexBox>
              <InputTitle></InputTitle>
              <TitleAndInput
                title="일일 비용한도"
                type="text"
                value="130USB"
                placeholder="일일 비용한도"
                score={true}
              />
            </FlexBox>

            <TitleAndInput
              title="환산비용"
              type="text"
              value="100,000원"
              placeholder="환산비용"
              disabled={true}
              score={true}
            />
          </InputLinkBox> */}
        </SettingBox>
      </CommmonBoxLayout>
    </CommonLayout>
  );
}

const SettingBox = styled.div`
  height: calc(50vh - 8rem);
  
  /* 관리자 섹션 반응형 레이아웃 */
  & > div {
    flex-wrap: wrap;
    
    & > div {
      flex: 1;
      min-width: 200px;
      
      /* InputTitle 고정 너비 해제 */
      h6 {
        width: auto;
        min-width: 6rem;
        white-space: nowrap;
      }
      
      /* Input 가변 너비 */
      input {
        flex: 1;
        min-width: 120px;
        max-width: 100%;
      }
    }
  }
`;


// const SettingTitle = styled(CommonBoxTitle)`
//   margin-bottom: 2.5rem;
// `;

// const PhoneCheckBox = styled(FlexBox)`
//   ${flex};
//   gap: 0.75rem;
// `;